import React, { useContext } from 'react';
import { DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Input, Segmented, Space, Tooltip } from 'antd';

import NoSiteAccessUsersContext from '@totem/components/services/remoteAccess/v2/noSiteAccess/NoSiteAccessUsersContext';
import { StatusFilter } from '@totem/components/services/remoteAccess/v2/users/types';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

type Props = {
  onRemoveSelected: () => void;
};

const NoSiteAccessUsersSearchBar = ({ onRemoveSelected }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const {
    rows,
    emailSearch,
    setEmailSearch,
    nameSearch,
    setNameSearch,
    statusFilter,
    setStatusFilter,
    selectedUserIds,
    onRefresh,
  } = useContext(NoSiteAccessUsersContext);

  const isRemoteAccessAdmin = permissions.remoteAccessAdmin.hasPermissions(
    userProfile,
    securityGroupCheckConstraintAny,
  );

  return (
    <Space wrap size="middle" style={{ marginBottom: 16 }}>
      <RecordCountBadge count={rows.length} />
      <Input
        placeholder="Email Search"
        value={emailSearch}
        allowClear
        onChange={(evt) => setEmailSearch(evt.target.value)}
        style={{ width: 220 }}
      />
      <Input
        placeholder="Name Search"
        value={nameSearch}
        allowClear
        onChange={(evt) => setNameSearch(evt.target.value)}
        style={{ width: 220 }}
      />
      <Segmented<StatusFilter>
        value={statusFilter}
        onChange={setStatusFilter}
        options={[
          { label: 'All', value: 'all' },
          { label: 'Active', value: 'ACTIVE' },
          { label: 'Stale', value: 'STALE' },
          { label: 'Never Logged In', value: 'NEVER LOGGED IN' },
        ]}
      />
      {isRemoteAccessAdmin && (
        <Button
          danger
          icon={<DeleteOutlined />}
          disabled={selectedUserIds.length === 0}
          onClick={onRemoveSelected}
        >
          Remove Selected ({selectedUserIds.length})
        </Button>
      )}
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

export default NoSiteAccessUsersSearchBar;
